var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6505_18493)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2042 4.78914C11.243 4.82783 11.2738 4.8738 11.2948 4.92442C11.3158 4.97503 11.3266 5.02928 11.3266 5.08408C11.3266 5.13888 11.3158 5.19313 11.2948 5.24374C11.2738 5.29436 11.243 5.34033 11.2042 5.37902L5.37219 11.2112C5.29397 11.2895 5.18788 11.3334 5.07726 11.3334C4.96663 11.3334 4.86054 11.2895 4.78232 11.2112C4.7041 11.133 4.66016 11.0269 4.66016 10.9163C4.66016 10.8057 4.7041 10.6996 4.78232 10.6214L10.6143 4.78914C10.653 4.75034 10.699 4.71956 10.7496 4.69856C10.8002 4.67756 10.8545 4.66675 10.9093 4.66675C10.9641 4.66675 11.0183 4.67756 11.0689 4.69856C11.1195 4.71956 11.1655 4.75034 11.2042 4.78914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78254 4.78914C4.74375 4.82783 4.71297 4.8738 4.69197 4.92442C4.67097 4.97503 4.66016 5.02928 4.66016 5.08408C4.66016 5.13888 4.67097 5.19313 4.69197 5.24374C4.71297 5.29436 4.74375 5.34033 4.78254 5.37902L10.6146 11.2112C10.6928 11.2895 10.7989 11.3334 10.9095 11.3334C11.0201 11.3334 11.1262 11.2895 11.2044 11.2112C11.2826 11.133 11.3266 11.0269 11.3266 10.9163C11.3266 10.8057 11.2826 10.6996 11.2044 10.6214L5.37241 4.78914C5.33371 4.75034 5.28774 4.71956 5.23713 4.69856C5.18652 4.67756 5.13227 4.66675 5.07747 4.66675C5.02268 4.66675 4.96842 4.67756 4.91781 4.69856C4.86721 4.71956 4.82124 4.75034 4.78254 4.78914Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6505_18493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.43ab6cc7a222120f590a25986e11a630.svg";
export { ForwardRef as ReactComponent };